import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router";
import i18n from "../../../i18n/i18n";
import { Button, Form } from "react-bootstrap";
import { useResetPasswordStore } from "./store/ForgotPasswordStore";
import { getResetPasswordToken, updatePassword } from "./core/_request";
import { validateEmail } from "../../../utilities/string";
import { Assets } from "../../../assets";

const ForgetPasswordWrapper = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [newpwd, setNewpwd] = useState<string>("");
  const [confirm, setConfirm] = useState<string>("");
  const [pwderror, setPwderror] = useState<string | null>("");
  const [confirmError, setConfirmError] = useState<string | null>("");
  const {
    email,
    setEmail,
    sentEmail,
    setEmailError,
    emailError,
    setSentEmail,
  } = useResetPasswordStore();
  const onValidateEmail = () => {
    if (!validateEmail(email)) {
      setEmailError(i18n.t("INVALID_EMAIL"));
    } else {
      setEmailError(null);
    }
  };
  const onValidateNewPassword = () => {
    if (newpwd?.length <= 0) {
      setPwderror("Mot de passe obligatoire");
      return false;
    } else if (newpwd?.length > 0 && newpwd?.length < 4) {
      setPwderror("Mot de passe invalide");
      return false;
    } else {
      setPwderror(null);
      return true;
    }
  };
  const onValidateConfirmPassword = () => {
    if (confirm !== newpwd) {
      setConfirmError("Mot de passe non identique");
      return false;
    } else {
      setConfirmError(null);
      return true;
    }
  };
  const onSendResetRequest = async () => {
    if (!validateEmail(email)) {
      setEmailError(i18n.t("INVALID_EMAIL"));
      // return;
    } else {
      const res = await getResetPasswordToken({ email });
      if (res && res?.success === "OK") {
        setSentEmail(true);
      }
    }
  };

  const onSaveNewPassword = async () => {
    if (!onValidateNewPassword() || !onValidateConfirmPassword()) {
      return;
    }

    const res = await updatePassword({
      token: token ?? "",
      password: confirm,
    });
    if (res && res?.success === "OK") {
      // setSentEmail(true);
      navigate("/auth/login", { replace: true });
    }
  };

  useEffect(() => {
    setEmail("");
  }, [sentEmail]);

  if (token) {
    return (
      <div className="card_container">
        <div className="d-flex flex-column align-items-center pt-4">
          <div className="d-flex justify-content-center p-4">
            <img src={Assets.imagesSvg.logo} width={"40%"} alt="Logo SEMS" />
          </div>
          <div className="w-50" style={{ maxWidth: 500 }}>
            <h4>Modifier votre mot de passe</h4>
            <div className="d-flex flex-column">
              <label className="mt-2">{"Nouveau mot de passe"}</label>
              <Form.Control
                value={newpwd}
                onChange={(e) => setNewpwd(e.target.value ?? "")}
                onBlur={onValidateNewPassword}
                className="w-100 m-0 ms-0 mt-2"
                placeholder="Nouveau mot de passe"
              />
              {pwderror && <div className="text-danger fs-6">{pwderror}</div>}

              <label className="mt-2">{"Confirmer le mot de passe"}</label>
              <Form.Control
                value={confirm}
                onChange={(e) => setConfirm(e.target.value ?? "")}
                onBlur={onValidateConfirmPassword}
                className="w-100 m-0 ms-0 mt-2"
                placeholder="Mot de passe"
              />
              {confirmError && (
                <div className="text-danger fs-6">{confirmError}</div>
              )}
              <Button className="mt-3" onClick={onSaveNewPassword}>
                {i18n.t("Enregistrer")}
              </Button>
            </div>
          </div>
          <NavLink
            to={"/auth/login"}
            onClick={() => {
              setSentEmail(false);
            }}
            className={"mt-2"}
          >
            Se connecter
          </NavLink>
        </div>
      </div>
    );
  }

  return (
    <div className="card_container">
      <div className="d-flex flex-column align-items-center pt-4">
        <div className="d-flex justify-content-center p-4">
          <img src={Assets.imagesSvg.logo} width={"40%"} alt="Logo SEMS" />
        </div>
        {sentEmail && (
          <div className="d-flex flex-column align-items-center">
            <p>
              Un mail vous a été envoyé, veuillez vérifier votre boite mail.
            </p>
          </div>
        )}
        {!sentEmail && (
          <>
            {!sentEmail && (
              <div className="d-flex flex-column align-items-center">
                <h5>{i18n.t("TYPE_YOUR_EMAIL")}</h5>
                <Form.Control
                  value={email}
                  onChange={(e) => setEmail(e.target.value ?? "")}
                  onBlur={onValidateEmail}
                  className="w-50 m-4"
                  placeholder="Adresse mail"
                />
                {emailError && (
                  <div className="text-danger fs-6">{emailError}</div>
                )}
                <Button className="mt-3" onClick={onSendResetRequest}>
                  {i18n.t("SEND")}
                </Button>
              </div>
            )}
            {sentEmail && (
              <div>
                <h5>Vérifier votre boite mail</h5>
              </div>
            )}
          </>
        )}
        <NavLink
          to={"/auth/login"}
          onClick={() => {
            setSentEmail(false);
          }}
          className={"mt-2"}
        >
          Se connecter
        </NavLink>
      </div>
    </div>
  );
};

export default ForgetPasswordWrapper;
